export enum TravelAlertTypes {
  CICLO_TRANSVERSAL = "Ciclo transversal (D+1)",
  DEFICIT_COMANDOS_HARDWARE = "Déficit de comandos de hardware enviados",
  DEFICIT_COMANDOS_SENSOR = "Déficit de comandos de sensor ativo (IDLE elevado)",
  FALHA_POSICIONAMENTO_GPS = "Falha de posicionamento GPS",
  INCONSISTENCIA_FLUXO_LOGISTICO = "Inconsistência de fluxo logístico",
  CAN_TRAVADO = "Informações de CAN travadas (completas ou parciais)",
  INSTABILIDADE_GPRS = "Instabilidade de conexão GPRS",
  FALSO_POSITIVO_DESCARGA = "Falsos positivos de descarga"
}

export enum TravelAlertTypesID {
  CICLO_TRANSVERSAL = "c3db5f07-0adb-4647-ae8b-2380a898b95b",
  DEFICIT_COMANDOS_HARDWARE = "909443c5-7b7d-40a2-ae79-0534b90a8628",
  DEFICIT_COMANDOS_SENSOR = "0445b44e-9081-436e-904b-62bacdf2ec57",
  FALHA_POSICIONAMENTO_GPS = "2f6349ac-719a-4b35-a161-45f513bb91e2",
  INCONSISTENCIA_FLUXO_LOGISTICO = "8abca603-c980-431c-8a67-cf8cbcebc754",
  CAN_TRAVADO = "e2f32d7a-3076-4ba5-879e-f0333db7c232",
  INSTABILIDADE_GPRS = "136db83f-46a7-4837-970c-21e726fc978f",
  FALSO_POSITIVO_DESCARGA = "a1b2c3d4-5e6f-7a8b-9c0d-e1f2a3b4c5d6"
}
